import { useIntl } from 'react-intl'
import {KTSVG} from '../../../../../_dashboard/helpers'
import {useListView} from '../core/ListViewProvider'

const CmsServiceEditModalHeader = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
const intl=useIntl()
  return (
    <div className='modal-header'>
      {/* begin::Modal title */}
      <h2 className='fw-bolder'> {itemIdForUpdate ? intl.formatMessage({id:'COMMON.UPDATE_OPTION'}) : intl.formatMessage({id:'COMMON.ADD_OPTION'})}</h2>
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        data-kt-cms-service-modal-action='close'
        onClick={() => setItemIdForUpdate(undefined)}
        style={{cursor: 'pointer'}}
      >
        <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
      </div>
      {/* end::Close */}
    </div>
  )
}

export {CmsServiceEditModalHeader}
